export const actions = {
  SET_RATING: 'SET_RATING',
};

export const setRating = ( profile ) => {
    return {
        type: actions.SET_RATING,
        personId: profile.id,
        rating: profile.rating,
    }
};


// WEBPACK FOOTER //
// src/client/components/site/features/profile/actions/rating.js